import { openDB, type IDBPDatabase } from 'idb';

// Separate DB from sync_queue so the two stores can evolve independently.
const DB_NAME = 'eva-field-blobs';
const DB_VERSION = 1;
const STORE = 'blobs';

let dbPromise: Promise<IDBPDatabase> | null = null;
function db(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(d) {
        if (!d.objectStoreNames.contains(STORE)) {
          d.createObjectStore(STORE);
        }
      },
    });
  }
  return dbPromise;
}

export async function saveBlob(key: string, blob: Blob): Promise<void> {
  const d = await db();
  await d.put(STORE, blob, key);
}

export async function loadBlob(key: string): Promise<Blob> {
  const d = await db();
  const blob = (await d.get(STORE, key)) as Blob | undefined;
  if (!blob) throw new Error(`blob not found: ${key}`);
  return blob;
}

export async function deleteBlob(key: string): Promise<void> {
  const d = await db();
  await d.delete(STORE, key);
}
